import styled from "styled-components";

export const Dialog = styled.div<{ opened?: boolean }>`
  opacity: ${(props) => (props.opened ? "1" : "0")};
  pointer-events: ${(props) => (props.opened ? "auto" : "none")};
  position: fixed;
  z-index: 9999999;
  background-color: white;
  bottom: 88px;
  right: 95px;
  width: 70%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  transition: all 0.4s ease;

  border-radius: 20px 20px 0px 20px;
  -moz-border-radius: 20px 20px 0px 20px;
  -webkit-border-radius: 20px 20px 0px 20px;
`;

export const DialogHeader = styled.div`
  display: flex;
  font-size: 0.8rem;
  margin: 5px;
`;

export const DialogTitle = styled.h3`
  white-space: pre-wrap;
  padding: 5px 10px;
  color: #005783;
`;

export const DialogClose = styled.div`
  margin-right: 5px;
  width: 20px;
  font-weight: bold;
  color: #000;
  font-size: 20px;
  color: rgb(173, 173, 173);
  cursor: pointer;
`;

export const DialogText = styled.p`
  padding: 5px 10px;
  color: #005783;
`;
